<div *ngIf="estadisticas != null">
    <div class="flex-2 flex flex-column gap-2">
        <div class="flex align-items-center gap-2" style="min-width:3.9rem; cursor: pointer;">
            <div *ngIf="estadisticas.stats?.qtyrequeridos === 0 && estadisticas.stats?.qtycumplidos === 0">
                <p-tag icon="pi pi-info-circle"
                       [style]="{ background: '#3B82F6' }"
                       styleClass="text-xs"
                       [value]="generarInfoCantidades()"
                       [pTooltip]="estadisticas.stats?.qtyrequeridos===0 ? '  trámite sin requisitos' : ''"/>
            </div>

            <div *ngIf="estadisticas.stats?.qtyrequeridos! > 0 && estadisticas.stats?.qtycumplidos! < estadisticas.stats?.qtyrequeridos!">
                <p-tag icon="pi pi-check-square"
                       [style]="{ background: 'rgb(255, 165, 0)' }"
                       styleClass="text-xs"
                       (click)="openDialog()"
                       [value]="generarInfoCantidades()"
                       [pTooltip]="estadisticas.stats?.qtycumplidos + ' requisitos de ' + estadisticas.stats?.qtyrequeridos + ' por completar'"/>
            </div>

            <div *ngIf="estadisticas.stats?.qtyrequeridos! > 0 && estadisticas.stats?.qtycumplidos! >= estadisticas.stats?.qtyrequeridos!">
                <p-tag icon="pi pi-check-square"
                       [style]="{ background: 'rgb(0, 128, 0)' }"
                       styleClass="text-xs"
                       (click)="openDialog()"
                       [value]="generarInfoCantidades()"
                       [pTooltip]="estadisticas.stats?.qtycumplidos + ' requisitos completados'"/>
            </div>
        </div>
    </div>
</div>
